export default __webpack_public_path__ + "static/media/personality_INTj.96d7d852.png";